import { FiInfo } from "react-icons/fi";
import { BaseIconBoxProps, IconBox } from "./IconBox";

export const InfoBox = ({ children, className }: BaseIconBoxProps) => {
	return (
		<IconBox borderColor='border-blue-200' icon={FiInfo} iconFill="fill-blue-300" iconStroke="stroke-white">
			{children}
		</IconBox>
	);
};
